import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const Languages = (props: Props) => {
  return (
    <FilterAutocomplete
      label={'Languages'}
      fieldName={'languages'}
      fieldPath={'mediaDetails.languages'}
    />
  )
}
